import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { interventions } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const InterventionsSection = () => {
  return (
    <section id="interventions" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Interventions
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {interventions.map((intervention) => (
            <Card
              key={intervention.id}
              className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group overflow-hidden"
            >
              <CardContent className="p-8 relative">
                <div className="absolute top-0 right-0 w-32 h-32 bg-orange-100 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
                <div className="relative z-10">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    {intervention.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {intervention.description}
                  </p>
                  <Button
                    variant="ghost"
                    className="text-orange-600 hover:text-orange-700 p-0 group-hover:translate-x-2 transition-transform duration-200"
                  >
                    Read More <ArrowRight className="ml-2" size={18} />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InterventionsSection;